import { render, staticRenderFns } from "./DiscLdg.vue?vue&type=template&id=5e4ba24f&"
import script from "./DiscLdg.vue?vue&type=script&lang=js&"
export * from "./DiscLdg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports